import { render, staticRenderFns } from "./CnicPromoClientComponent.vue?vue&type=template&id=d47e1788"
import script from "./CnicPromoClientComponent.vue?vue&type=script&lang=js"
export * from "./CnicPromoClientComponent.vue?vue&type=script&lang=js"
import style0 from "./CnicPromoClientComponent.vue?vue&type=style&index=0&id=d47e1788&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports